import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RouteScrollToTop from "./helper/RouteScrollToTop";
import HomePageOne from "./pages/HomePageOne";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import AccountPage from "./pages/AccountPage";
import ContactPage from "./pages/ContactPage";
import PhosphorIconInit from "./helper/PhosphorIconInit";
import VendorPage from "./pages/VendorPage";
import VendorDetailsPage from "./pages/VendorDetailsPage";
import VendorTwoPage from "./pages/VendorTwoPage";
import VendorTwoDetailsPage from "./pages/VendorTwoDetailsPage";
import BecomeSellerPage from "./pages/BecomeSellerPage";
import WishlistPage from "./pages/WishlistPage";
import { UserProvider } from "./context/UserContext";
import { SellerProvider } from "./context/SellerContext";
import { Provider } from 'react-redux';
import { store } from './redux/store';
import PendingSellers from "./pages/admin/PendingSellers";
import ForgotPassword from "./pages/ForgotPassword";
import AdminLogin from './pages/AdminLogin';
import PartnerLogin from './pages/PartnerLogin';
import SellerRegistrationPage from './pages/SellerRegistrationPage';

// 👇 NEW ADMIN IMPORTS
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/Dashboard';
import SellersPage from './pages/admin/Sellers';
import SellerDetails from './pages/admin/SellerDetails';
import AdminOrdersPage from './pages/admin/Orders';
import AdminProductsPage from './pages/admin/Products';
import AdminCategoriesPage from './pages/admin/Categories';
import AdminInventoryPage from './pages/admin/Inventory';
import AdminCustomersPage from './pages/admin/Customers';
import AdminPaymentsPage from './pages/admin/Payments';
import AdminMessagesPage from './pages/admin/Messages';
import AdminProfilepage from './pages/admin/Profile';
import AdminReviewsPage from './pages/admin/Reviews';
import AdminPayoutsPage from './pages/admin/Payouts';
import AdminCouponsPage from './pages/admin/Coupons';
import AdminOffersPage from './pages/admin/Offers';
import AdminReportsPage from './pages/admin/Reports';
import AdminAnalyticsPage from './pages/admin/Analytics';
import AdminNotificationspage from './pages/admin/Notifications';
import AdminReturnsPage from './pages/admin/Returns';


// 👇 SELLER IMPORTS
import SellerLayout from "./components/seller/SellerLayout";
import SellerDashboard from "./pages/seller/Dashboard";
import ProductsPage from "./pages/seller/Products";
import AddProductPage from "./pages/seller/AddProduct";
import SellerOrdersPage from "./pages/seller/Orders";
import SellerEarningsPage from "./pages/seller/Earnings";
import OrderSuccessPage from "./pages/OrderSuccessPage";
import WalletPage from "./pages/seller/Wallet";
import ReviewsPage from "./pages/seller/Reviews";
import SettingsPage from "./pages/seller/Settings";
import NotificationsPage from "./pages/seller/Notifications";
import SupportPage from "./pages/seller/Support";
import ReturnsPage from "./pages/seller/Returns";

// 👇 PARTNER IMPORTS
import PartnerLayout from './components/partner/PartnerLayout';
import PartnerDashboard from './pages/partner/Dashboard';
import PartnerAnalytics from './pages/partner/Analytics';
import PartnerOrders from './pages/partner/Orders';
import PartnerRevenue from './pages/partner/Revenue';
import PartnerUsers from './pages/partner/Users';
import PartnerSellers from './pages/partner/Sellers';
import PartnerProducts from './pages/partner/Products';
import PartnerReports from './pages/partner/Reports';
import PartnerNotifications from './pages/partner/Notifications';
import PartnerProfile from './pages/partner/Profile';

// 👇 CUSTOMER IMPORTS
import CustomerLayout from './components/customer/CustomerLayout';
import CustomerDashboard from './pages/customer/CustomerDashboard';
import CustomerOrders from './pages/customer/CustomerOrders';
import CustomerProfile from './pages/customer/CustomerProfile';
import CustomerAddresses from './pages/customer/CustomerAddresses';


function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <UserProvider>
          <RouteScrollToTop />
          <PhosphorIconInit />
          <ToastContainer position="top-right" autoClose={3000} />
          <Routes>
            {/* Public Routes */}
            <Route exact path="/" element={<HomePageOne />} />
            <Route exact path="/shop" element={<ShopPage />} />
            <Route exact path="/product-details/:id" element={<ProductDetailsPageOne />} />
            <Route exact path="/cart" element={<CartPage />} />
            <Route exact path="/checkout" element={<CheckoutPage />} />
            <Route exact path="/wishlist" element={<WishlistPage />} />
            <Route exact path="/order-success" element={<OrderSuccessPage />} />
            <Route exact path="/become-seller" element={<BecomeSellerPage />} />
            <Route exact path="/account" element={<AccountPage />} />
            <Route exact path="/contact" element={<ContactPage />} />
            <Route exact path="/vendor" element={<VendorPage />} />
            <Route exact path="/vendor-details" element={<VendorDetailsPage />} />
            <Route exact path="/vendor-two" element={<VendorTwoPage />} />
            <Route exact path="/vendor-two-details" element={<VendorTwoDetailsPage />} />
            
            {/* Customer Dashboard Routes */}
            <Route path="/account" element={<CustomerLayout />}>
              <Route path="dashboard" element={<CustomerDashboard />} />
              <Route path="orders" element={<CustomerOrders />} />
              <Route path="profile" element={<CustomerProfile />} />
              <Route path="address" element={<CustomerAddresses />} />
            </Route>

            {/* Seller Routes */}
            <Route exact path="/become-seller" element={<BecomeSellerPage />} />
            <Route exact path="/seller/register" element={<SellerRegistrationPage />} />
            
            <Route path="/seller" element={<SellerProvider><SellerLayout /></SellerProvider>}>
              <Route path="dashboard" element={<SellerDashboard />} />
              <Route path="products" element={<ProductsPage />} />
              <Route path="products/add" element={<AddProductPage />} />
              <Route path="orders" element={<SellerOrdersPage />} />
              <Route path="earnings" element={<SellerEarningsPage />} />
              <Route path="wallet" element={<WalletPage />} />
              <Route path="reviews" element={<ReviewsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="notifications" element={<NotificationsPage />} />
              <Route path="support" element={<SupportPage />} />
              <Route path="returns" element={<ReturnsPage />} />
            </Route>

            {/* Partner Routes */}
            <Route path="/partner" element={<PartnerLayout />}>
              <Route path="dashboard" element={<PartnerDashboard />} />
              <Route path="analytics" element={<PartnerAnalytics />} />
              <Route path="orders" element={<PartnerOrders />} />
              <Route path="revenue" element={<PartnerRevenue />} />
              <Route path="users" element={<PartnerUsers />} />
              <Route path="sellers" element={<PartnerSellers />} />
              <Route path="products" element={<PartnerProducts />} />
              <Route path="reports" element={<PartnerReports />} />
              <Route path="notifications" element={<PartnerNotifications />} />
              <Route path="profile" element={<PartnerProfile />} />
            </Route>
            
            {/* Admin Login (No Layout) */}
            <Route exact path="/admin/login" element={<AdminLogin />} />
            
            {/* 👇 NEW ADMIN ROUTES WITH LAYOUT */}
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="sellers" element={<SellersPage />} />
              <Route path="sellers/details/:id" element={<SellerDetails />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="sellers/pending" element={<PendingSellers />} />
              <Route path="orders" element={<AdminOrdersPage />} />
              <Route path="products" element={<AdminProductsPage />} />
              <Route path="categories" element={<AdminCategoriesPage />} />
              <Route path="inventory" element={<AdminInventoryPage />} />
              <Route path="customers" element={<AdminCustomersPage />} />
              <Route path="payments" element={<AdminPaymentsPage />} />
              <Route path="messages" element={<AdminMessagesPage />} />
              <Route path="payouts" element={<AdminPayoutsPage />} />
              <Route path="reviews" element={<AdminReviewsPage />} />
              <Route path="coupons" element={<AdminCouponsPage />} />
              <Route path="offers" element={<AdminOffersPage />} />
              <Route path="reports" element={<AdminReportsPage />} />
              <Route path="analytics" element={<AdminAnalyticsPage />} />
              <Route path="notifications" element={<AdminNotificationspage />} />
              <Route path="profile" element={<AdminProfilepage />} />
              <Route path="returns" element={<AdminReturnsPage />} />
            </Route>
            <Route exact path="/partner/login" element={<PartnerLogin />} />
            <Route exact path="/partner/dashboard" element={<PartnerDashboard />} />
            
            {/* Other Routes */}
            <Route exact path="/forgot-password" element={<ForgotPassword />} />
          </Routes>
        </UserProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;